<template>
  <layout-auth>
    <v-container class="py-8">
      <v-row>
        <v-col>
          <h1 class="text-h4 font-weight-light py-5">
            {{ $t("invoices.resumenConfirmacionBaja") }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <label style="font-size: 18px" class="font-weight-light">
            {{ $t("invoices.datosAnticipos") }}</label
          >
          <h3 class="text-subtitle-1">
            {{ $t("invoices.datosBajaAncipoAutomatico2") }}
          </h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <label class="second-type-label">
            {{ $t("invoices.empesaClintePagador") }}
          </label>
          <p class="font-weight-medium text-subtitle-1">{{ model.empresa }}</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12" md="4" lg="3">
          <label class="second-type-label"> {{ $t("invoices.cuentaAbono") }}</label>
          <p class="text-subtitle-1">{{ model.cuenta }}</p>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <label class="second-type-label"> {{ $t("invoices.fechaSolicitud") }}</label>
          <p class="text-subtitle-1">{{ model.fecha }}</p>
        </v-col>
      </v-row>
      <v-row class="py-10">
        <v-col cols="12" sm="12" lg="12">
          <v-btn
            v-if="!confirmed"
            depressed
            :color="entityConfig.primaryColor"
            :style="`color: ${entityConfig.secondaryColor}`"
            class="float-end m-2 v-btn-width-default"
            @click="confirmRemove"
          >
            {{ $t("users.confirm") }}
          </v-btn>
          <v-btn
            v-else
            depressed
            @click="finalizar"
            :color="entityConfig.primaryColor"
            :style="`color: ${entityConfig.secondaryColor}`"
            class="float-end m-2 v-btn-width-default"
          >
            {{ $t("supplierData.finish") }}
          </v-btn>
          <v-btn
            v-if="!confirmed"
            outlined
            @click="$router.go(-1)"
            :color="entityConfig.primaryColor"
            class="float-end m-2 v-btn-width-default"
          >
            {{ $t("users.goBack") }}
          </v-btn>
          <v-btn
          v-else
            plain
            :color="entityConfig.primaryColor"
            class="float-end m-2 v-btn-width-default"
            @click="print"
          >
            <v-icon left> mdi-printer-outline </v-icon>
            {{ $t("users.print") }}
          </v-btn>
        </v-col>
        <v-col></v-col>
      </v-row>
    </v-container>
    <overlay :visible="spinner"></overlay>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import Overlay from "../../components/layouts/overlay.vue";
import Api from "../../Services/index";

export default {
  components: { LayoutAuth, Overlay },
  data() {
    return {
      spinner: false,
      confirmed: false,
      entityConfig: {},
      model: {
        empresa: "",
        cuenta: "",
        fecha: "",
        factura: "",
      },
    };
  },
  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    let autoAdvance = JSON.parse(
      sessionStorage.getItem("removeThisAutoAdvance")
    );

    if (autoAdvance) {
      let date = new Date();
      let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
      let mo = new Intl.DateTimeFormat("es", { month: "short" }).format(date);
      let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
      this.model.empresa = autoAdvance.nameClient;
      this.model.cuenta = autoAdvance.iban;
      this.model.fecha = `${da} ${mo} ${ye}`;
      Api.defaults.headers.common["Authorization"] =
        "Bearer " + sessionStorage.getItem("authtoken");
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    print() {
      window.print();
    },
    confirmRemove() {
      this.spinner = true;
      let userdata = JSON.parse(sessionStorage.getItem("userData"));
      let userId = userdata.supplierId.trim();
      let autoAdvance = JSON.parse(
        sessionStorage.getItem("removeThisAutoAdvance")
      );

      Api.delete(
        `/proveedores/${userId}/anticipos-automaticos?numCliente=${autoAdvance.numClient}&tipoConfirming=N`
      )
        .then(() => {
          sessionStorage.removeItem("removeThisAutoAdvance");
          this.$toast.success("Se ha dado de baja al anticipo automatico.");
          this.confirmed = true;
        })
        .catch((error) => {
          this.$showError(this, error.response.data);
        })
        .finally(() => {
          this.spinner = false;
        });
    },
    finalizar() {
      this.$router.push("/anticipo-automatico/baja");
    },
  },
};
</script>
